import React from 'react';
import BaseModal, {
	BaseModalProps,
} from '../../../../../Base/Components/BaseModal/BaseModal';
import MedicalHistoryConfigCreate from './MedicalHistoryConfigCreate';

interface Props extends BaseModalProps {
	onCreate: () => void;
}

const MedicalHistoryConfigCreateModal: React.FC<Props> = props => (
	<BaseModal {...props} title='component.medicalHistoryConfigCreate.title'>
		<MedicalHistoryConfigCreate onCreate={props.onCreate} />
	</BaseModal>
);

export default MedicalHistoryConfigCreateModal;
